"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATIONS_TABLE_DATA_INDICES = void 0;
exports.ORGANIZATIONS_TABLE_DATA_INDICES = {
    INSTANCE_URL: 'instanceUrl',
    IS_SANDBOX: 'isSandbox',
    NAME: 'name',
    SALESFORCE_USERNAME: 'salesforceUsername'
};
//# sourceMappingURL=ORGANIZATIONS_TABLE_DATA_INDICES.js.map